import { render, staticRenderFns } from "./AddReply.vue?vue&type=template&id=55c587d8&scoped=true&"
import script from "./AddReply.vue?vue&type=script&lang=js&"
export * from "./AddReply.vue?vue&type=script&lang=js&"
import style0 from "./AddReply.vue?vue&type=style&index=0&id=55c587d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c587d8",
  null
  
)

export default component.exports